// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget[data-v-48bbb4da]{min-width:322px;max-width:1200px;margin-left:auto;margin-right:auto}.widget--wide[data-v-48bbb4da]{min-width:514px}", ""]);
// Exports
module.exports = exports;
